import styled from "styled-components";
import { mixins } from "@similarweb/styles";

export const StyledTruncatedInnerText = styled.span`
    ${mixins.truncateText()};
`;